var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '../../utils';
import { ProgressBar } from '../progress-bar';
import * as styles from './score-card.styles';
import { ChevronRightIcon } from '@heroicons/react/solid';
export var ScoreCard = function (_a) {
    var image = _a.image, mainText = _a.mainText, secondaryText = _a.secondaryText, _b = _a.textPosition, textPosition = _b === void 0 ? 'center' : _b, hint = _a.hint, hintClassName = _a.hintClassName, progressBarClassName = _a.progressBarClassName, className = _a.className, currentPoints = _a.currentPoints, maxPoints = _a.maxPoints, bgColour = _a.bgColour, barColour = _a.barColour, barBgColour = _a.barBgColour, textColour = _a.textColour, onClick = _a.onClick;
    var percentageScore = (currentPoints / maxPoints) * 100;
    return (_jsx("div", __assign({ className: classNames(className, "".concat(styles.wrapper, " bg-").concat(bgColour)), onClick: function () {
            !!onClick && onClick();
        } }, { children: _jsxs("div", __assign({ className: styles.content }, { children: [!!image && image, _jsx("div", __assign({ className: classNames(progressBarClassName, 'w-full'), style: { height: 80 } }, { children: _jsx(ProgressBar, { className: "h-2", label: mainText, subLabel: secondaryText || '', hint: hint, hintClassName: hintClassName, textPosition: textPosition, value: percentageScore, primaryColour: barColour, secondaryColour: barBgColour, textColour: textColour }) })), !!onClick && _jsx(ChevronRightIcon, { className: styles.menuChevron })] })) })));
};
export default ScoreCard;
//# sourceMappingURL=score-card.js.map